import React, { useState } from "react";
import { Image } from "react-bootstrap";
import IconPlus from "../../../assets/icon-plus.svg";
import closeIcon from "../../../assets/closeIcon.svg";

import { ConfirmationComponent } from "../../ConfirmationComponent";
import { VIDEO_FORMATS } from "../../../constant";
import { VideoPlayerModal } from "../modal/videoPlayerModal";
import AttachmentIcon from "../../../assets/attachment-red-icon.svg";

export function DisplayAttachments({
  onTogglePopUp = () => {},
  onRemoveFile = () => {},
  isAgendaAttachment,
  filesArr = [],
  removeRequired = true,
  addAttchementRequired = true,
  classes = "",
  buttonTitle
}) {
  const [state, setState] = useState({ popUp: false, item: null });
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const [videoTitle, setVideoTitle] = useState(null);

  const onToogleRemovePopUp = value => {
    setState(prevState => {
      return { popUp: !prevState.popUp, item: value };
    });
  };

  const onRemove = () => {
    onRemoveFile(state.item);
    onToogleRemovePopUp(state.item);
  };

  const showVideoPlayerModal = () => {
    return (
      <VideoPlayerModal
        showVideoModal={showVideoModal}
        url={videoUrl}
        videoTitle={videoTitle}
        onClose={() => {
          setShowVideoModal(false);
          setVideoUrl(null);
          setVideoTitle(null);
        }}
      />
    );
  };

  return (
    <section className={`display-attachments-section-forward ${classes}`}>
      <ConfirmationComponent
        show={state.popUp}
        modalClass={"confirmation-modal"}
        saveHandler={onRemove}
        closeHandler={onToogleRemovePopUp}
        content={"Are you sure you want to do this?"}
      />
      {addAttchementRequired ? (
        <div
          className={`add-files ${buttonTitle ? "add-attachment" : ""}`}
          onClick={() => onTogglePopUp()}
        >
          {isAgendaAttachment ? (
            <Image src={AttachmentIcon} alt="Plus Icon" />
          ) : (
            <Image src={IconPlus} alt="Plus Icon" />
          )}
          <div className="add-file-text">
            {buttonTitle ? buttonTitle : "Add"}
          </div>
        </div>
      ) : null}

      {filesArr &&
        filesArr.map(value => {
          console.log("value", value);
          if (value && value !== undefined && Object.keys(value).length !== 0) {
            const extension = value.name.substr(
              value.name.lastIndexOf(".") + 1,
              value.name.length
            );
            let name;
            let title;
            if (value.name !== null && value.name !== undefined) {
              name =
                value.name.length > 20
                  ? value.name.substring(0, 20) + "..."
                  : value.name;
            }
            if (value.title !== null && value.title !== undefined) {
              title =
                value.title.length > 20
                  ? value.title.substring(0, 20) + "..."
                  : value.title;
            }
            console.log("name", name);
            console.log("title", title);
            return (
              <div className="uploaded-file-wrapper">
                <div className="uploaded-file">
                  {removeRequired ? (
                    <div
                      className="remove-file"
                      onClick={() => onToogleRemovePopUp(value)}
                    >
                      <Image src={closeIcon} alt="Plus Icon" />
                    </div>
                  ) : null}
                  <div className="file-detail">
                    <div>
                      {VIDEO_FORMATS.includes(extension) ? (
                        <div className="video-upload-icon" />
                      ) : (
                        <div className="upload-icon">
                          <span>{extension}</span>
                        </div>
                      )}
                    </div>
                    {!VIDEO_FORMATS.includes(extension) ? (
                      <a target="_blank" href={value.s3Url}>
                        {title || name}
                      </a>
                    ) : (
                      <div
                        className="video-player pl-1"
                        onClick={() => {
                          setShowVideoModal(true);
                          setVideoUrl(value.s3Url);
                          setVideoTitle(value.title || value.name);
                        }}
                      >
                        {value.title || value.name}
                      </div>
                    )}
                    {showVideoModal === true && showVideoPlayerModal()}
                  </div>
                </div>
              </div>
            );
          }
        })}
    </section>
  );
}
